export default "__VITE_ASSET__f5e00d3b__"